import { fuseAnimations } from '@fuse/animations';
import { ChangeDetectionStrategy, Component, inject, signal, ViewEncapsulation } from "@angular/core";
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from "@angular/router";
import { LoadingIcon } from '../loading/loading.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'navigation-spinner',
    templateUrl: './navigation-spinner.component.html',
    styleUrls: ['./navigation-spinner.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: fuseAnimations,
    imports: [ LoadingIcon ]
})
export class NavigationSpinnerComponent
{
    private _router: Router = inject(Router);
    loading = signal<boolean>(false);

    constructor()
    {
        this._router.events
            .pipe(takeUntilDestroyed())
            .subscribe(e =>
            {
                if (e instanceof NavigationStart) {
                    this.loading.set(true);
                    return;
                }

                if (e instanceof NavigationEnd || e instanceof NavigationCancel || e instanceof NavigationError) {
                    this.loading.set(false);
                    return;
                }
            });
    }
}
